import { productSearch } from './product-search.i18n';

export const en = {
  productSearch,
};
